import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App.js';
import { SessionProvider } from './lib/session.js';
import Admin from './pages/Admin.js';
import ClipPage from './pages/ClipPage.js';
import Clips from './pages/Clips.js';
import Guide from './pages/Guide.js';
import Home from './pages/Home.js';
import Join from './pages/Join.js';
import NotFound from './pages/NotFound.js';
import './styles.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: 'clips', element: <Clips /> },
      { path: 'clip/:id', element: <ClipPage /> },
      { path: 'guide', element: <Guide /> },
      { path: 'join', element: <Join /> },
      { path: 'admin', element: <Admin /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  </React.StrictMode>,
);
